import { Property, ObjectWithLinks } from '../../../../common';

export class DialogData {
  property?: Property;
  response?: ObjectWithLinks[];
}
